import { Component } from '@angular/core';
import { ActivatedRoute, Params }   from '@angular/router';
import { OrganizationService } from '../_services/organization.service';
import 'rxjs/add/operator/switchMap';

import { Organization } from '../_models/organization';

@Component({
  moduleId: module.id,
  templateUrl: 'edit.org.component.html'
})

export class EditOrgComponent {
  model: Organization;
  error: string;
  loading: boolean;
  success: boolean;

  constructor(
    private route: ActivatedRoute,
    private organizationService: OrganizationService
  ){}

  ngOnInit(): void {
    this.route.params
      .switchMap((params: Params) => this.organizationService.getOrg(+params['id']))
      .subscribe(org => this.model = org);
  }

  editOrg(model: Organization) {
    this.error = null;
    this.loading = true;
    this.success = false;

    this.organizationService.editOrg(model)
      .then(org => {
        this.success = true;
        this.loading = false;
        this.model = org;
      })
      .catch(err => {
        this.error = JSON.parse(err._body).error;
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/orgs/edit.org.component.ts